const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api';

const PROJECTS = {
    CREATE_PROJECT: `${API_BASE_URL}/projects/create/`,
    UPDATE_PROJECT: `${API_BASE_URL}/projects/update/`,
    DELETE_PROJECT: `${API_BASE_URL}/projects/delete/`,
    USER_PROJECTS: `${API_BASE_URL}/projects/user-projects/`,
    PUBLIC_USER_PROJECTS: (profile_id) => `${API_BASE_URL}/projects/public-user-projects/${profile_id}/`,
    USER_PROJECT: (id) => `${API_BASE_URL}/projects/${id}/`,
    ALL_PROJECTS: `${API_BASE_URL}/projects/all-projects/`,
};

export default PROJECTS;